import { View, Text, StyleSheet } from 'react-native'
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'
import { useTranslation } from 'react-i18next'
import { fonts } from '../../lib/theme'
import { useThemeColors } from '../../lib/useThemeColors'
import { useCountdown } from '../Home/ui'

// Quando chiude la scelta: la prima informazione che serve mentre si sceglie (nella Home c'e' il cronometro grande).
// Oltre le 24 ore: giorno e ora ("Chiude lun 14 ott · 04:30"). Sotto le 24 ore: conto alla rovescia, in colore brand sotto le 2 ore.
export default function DeadlineLine({ date, time }) {
  const { t, i18n } = useTranslation()
  const tc = useThemeColors()
  const diff = useCountdown(date, time)
  if (!diff) return null
  const pad = (v) => String(v).padStart(2, '0')
  let text
  if (diff.days > 0) {
    const d = new Date(`${String(date).split('T')[0]}T${time}`)
    const when = `${d.toLocaleDateString(i18n.language, { weekday: 'short', day: 'numeric', month: 'short' })} · ${pad(d.getHours())}:${pad(d.getMinutes())}`
    text = t('pick.closes_at', { when })
  } else {
    text = t('pick.closes_in', { time: `${pad(diff.hours)}:${pad(diff.minutes)}:${pad(diff.seconds)}` })
  }
  const col = diff.urgent ? tc.rosaText : tc.textMuted
  return (
    <View style={s.row} accessible accessibilityRole="timer" accessibilityLabel={text}>
      <MaterialCommunityIcons name="clock-outline" size={15} color={col} />
      <Text style={[s.text, { color: col }, diff.urgent && { fontFamily: fonts.condensedBold }]}>{text}</Text>
    </View>
  )
}

const s = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', gap: 6, marginBottom: 10 },
  text: { fontSize: 13, fontVariant: ['tabular-nums'] },
})
